export default __webpack_public_path__ + "static/media/bigFlower.6b6edb19.png";